import { useQuery } from "@tanstack/react-query";
import { getSupabaseWithLogging } from "@/lib/hooks/api/utils";
import {
  TASK_WITH_RELATIONS_SELECT,
  applyTaskFilters,
  hydrateAssignedUsersForTasks,
} from "./helpers";

export function useTasks(params?: {
  page?: number;
  limit?: number;
  search?: string;
  contact_id?: string;
  ticket_id?: string;
  status?: string;
  priority?: string;
  assigned_to?: string;
  assigned_users?: string[];
  user_id?: string;
}) {
  return useQuery({
    queryKey: ["tasks", params],
    queryFn: async () => {
      const supabase = getSupabaseWithLogging();
      let query = supabase.from("contact_tasks").select(TASK_WITH_RELATIONS_SELECT);

      query = applyTaskFilters(query, params, { includeTicketId: true });

      if (params?.limit) {
        const offset = ((params.page || 1) - 1) * params.limit;
        query = query.range(offset, offset + params.limit - 1);
      }

      const { data, error } = await query.order("created_at", {
        ascending: false,
      });

      if (error) {
        console.error("Error fetching tasks:", error);
        throw new Error(error.message);
      }

      if (data && data.length > 0) {
        await hydrateAssignedUsersForTasks(data);
      }

      return data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
